import ReactDOM from "react-dom";
import App from "./App.js";
import config from "./config.js";

import "./styles/registration.scss";

ReactDOM.render(
  <App
    mode={config.mode}
    onSuccess={config.onSuccess}
    servicePath={config.servicePath}
    globalErr={config.globalErr}
    extraFields={config.extraFields}
    lang={config.lang}
    hash={config.hash}
    platformData={config.platformData}
    additional={config.additional}
  />,
  document.getElementById("root")
);
